import jsonTheme from "../../../theme/PowerBI-ColorTheme.json";
import { PbiEventHandler, PbiEvents } from "../entities";
import {
  BackgroundType,
  DisplayOption,
  LayoutType,
  TokenType,
  VisualContainerDisplayMode,
} from "powerbi-models";

export const getLayoutConfigSettings = (
  pageName: string,
  displayOption: DisplayOption,
  visuals = {},
) => {
  return {
    layoutType: LayoutType.Custom,
    customLayout: {
      displayOption: displayOption,
      pagesLayout: {
        [pageName]: {
          defaultLayout: {
            displayState: {
              mode: VisualContainerDisplayMode.Visible,
            },
          },
          visualsLayout: visuals,
        },
      },
    },
  };
};

export const getDefaultEmbedConfig = (
  currentReport: any | undefined,
  expandFilterPane = false,
  overrideTheme = false,
  hideFilters = false,
) => {
  if (!currentReport) return undefined;

  const settings = getEmbedConfigSettings(
    expandFilterPane,
    false,
    overrideTheme,
    hideFilters,
  );

  return {
    type: "report",
    id: currentReport?.embedReport?.reportId,
    embedUrl: currentReport?.embedReport?.embedUrl,
    accessToken: currentReport?.embedToken?.token,
    tokenType: TokenType.Embed,
    settings: settings,
    theme: overrideTheme ? undefined : { themeJson: jsonTheme[0] },
    // @ts-ignore
    filters: currentReport?.defaultModelFilters,
  };
};

export const getEmbedConfigSettings = (
  expandFilterPane = false,
  onFullScreen = false,
  overrideTheme = false,
  hideFilters = false,
) => {
  return {
    panes: {
      pageNavigation: {
        visible: onFullScreen,
      },
      filters: {
        expanded: expandFilterPane,
        visible: !hideFilters,
      },
    },
    background:
      onFullScreen || overrideTheme
        ? BackgroundType.Default
        : BackgroundType.Transparent,
  };
};

export const getPowerBiEventHandlers = (
  onLoaded: PbiEventHandler,
  onPageChange: PbiEventHandler,
) =>
  new Map<string, PbiEventHandler>([
    [PbiEvents.loaded, onLoaded],
    [PbiEvents.pagedChanged, onPageChange],
  ]);
